












































import { Component, Vue } from "vue-property-decorator"
import BeatBeat from "../../../src/beat-beat"

@Component
export default class Home extends Vue {

	isLoading = true

	private frame = 0
	private sound: BeatBeat = new BeatBeat("/sounds/Baltra-FadeAway.mp3")

	get hiddenClass() {
		return { visible: !this.isLoading }
	}

	get cssClass() {
		return { ["f" + this.frame]: true }
	}

	async mounted() {
		await this.sound.load()
		this.isLoading = false
	}

	destroyed() {
		this.sound.destroy()
	}

	play() {
		if (this.sound.isPlaying) return
		const video = this.$refs.video as HTMLVideoElement
		const times = [0, 1.1, 3.1, 6.2]
		this.sound.play((time: number) => {
			video.currentTime = times[this.frame]
			video.play()
			++this.frame
			if (this.frame >= times.length) this.frame = 0
		})
	}
}
